export default __webpack_public_path__ + "static/media/ComputoriaImageThree.e172c542.png";